<template>
  <a-layout-header class="header">
    <!-- <div
      class="header__logo"
      :style="{'backgroundImage': `url(${logo})`}"
      @click="handleClickLogo"
    /> -->
    <!-- <div
      class="d-flex"
      style="margin-left: 80px"
    >
      <div
        v-for="route in routesConfig"
        :key="route.path"
        class="menu-item"
        :class="{'active': route.path === selectedMenuPath}"
        @click="updateMenu(route.path)"
      >
        <BizIcon
          v-if="route.icon"
          :type="route.icon"
          style="margin-right: 5px"
        />
        {{ route.name }}
      </div>
    </div> -->
    <div class="header__user">
      <div style="color: var(--text-color-o-65); margin-right: 33px">
        {{ (userInfo || {}).merchant_full_name }}
      </div>
      <a-badge :dot="hasUnreadChangelog">
        <a-button icon="file-done" size="default" class="header__user__changelog" type="primary"
          ghost @click="showChangelogDrawer">更新日志</a-button>
      </a-badge>
      <!-- <a-divider type="vertical" />
      <a-select
        :value="(activeProduct||{}).activeRule"
        style="width: 140px; margin-right: 20px; margin-left: 20px"
        @change="changeProduct"
      >
        <a-select-option
          v-for="product in productAppList"
          :key="product.activeRule"
          :value="product.activeRule"
        >{{ product.meta.title }}</a-select-option>
      </a-select> -->
      <!-- <div class="header__theme-switch">
        <a-switch
          :checked="theme === THEMES.DARK"
          @change="switchTheme"
        />
        <div style="color: var(--text-color-o-65)">切换{{ theme === THEMES.DARK ? '浅色' : '深色' }}</div>
      </div> -->
      <a-divider type="vertical" class="header__divider" />
      <!-- 通知（目前接入的是小程序后台通知） -->
      <Notify @pwdShow="showEditPwdModal = true" />
      <a-divider type="vertical" />
      <a-dropdown :visble="showDropDown" @visibleChange="visibleChange">
        <div
          :class="
            showDropDown
              ? 'header__user__config header__user__config__active'
              : 'header__user__config'
          ">
          <BizIcon
            class="header__user__icon"
            type="iconhebingxingzhuang"
            style="margin-left: 8px" />
          <span
            class="header__user__name"
            style="margin-left: 8px; color: var(--text-color-o-65)">
            {{ (userInfo || {}).real_name }}
          </span>
        </div>
        <a-menu slot="overlay" class="header__user__menu">
          <a-menu-item
            v-if="userInfo && userInfo.isAdmin"
            class="header__user__menu__item"
            @click="$router.push('/main/account')">
            账号管理
          </a-menu-item>
          <a-menu-item
            v-if="userInfo && userInfo.isAdmin"
            class="header__user__menu__item"
            @click="$router.push('/main/role')">
            角色管理
          </a-menu-item>
          <!-- <a-menu-item
            class="header__user__menu__item"
            @click="$router.push('/main/store')"
          >门店组</a-menu-item> -->
          <!-- <a-menu-item
            v-if="activeProduct && activeProduct.name === 'mvp'"
            class="header__user__menu__item"
            @click="$router.push('/mvp/insight/monitor')"
          >监控设置</a-menu-item> -->
          <a-menu-item
            class="header__user__menu__item"
            @click="handleTenantQuery">
            租户查询
          </a-menu-item>
          <a-menu-item
            class="header__user__menu__item"
            @click="showEditPwdModal = true">
            修改密码
          </a-menu-item>
          <a-menu-item
            class="header__user__menu__item header__user__menu__item--logout"
            @click="handleLogout">
            退出登录
          </a-menu-item>
        </a-menu>
      </a-dropdown>
      <template v-if="contractInfo.expireTime">
        <a-divider type="vertical" />
        <div class="contract">
          <div class="contract-state">{{ contractStateText }}</div>
          <div class="contract-date">到期时间：{{ contractInfo.expireTime }}</div>
        </div>
      </template>
    </div>
    <aside>
      <EditPwdDrawer
        v-if="showEditPwdModal"
        :visible="showEditPwdModal"
        @ok="handleEditPwd"
        @cancel="handleEditPwdCancel" />
      <ChangelogDrawer
        :visible="showChangelogModal"
        :log-content="changelogContent"
        @close="handleChangelogClose" />
    </aside>
    <TenantDetail :visible.sync="tenantModalVisible" />
  </a-layout-header>
</template>

<script>
import { initGlobalState } from 'qiankun';
import { mapState } from 'vuex';
import { THEMES } from '@/consts';
import BizIcon from '@/components/BizIcon';
import { getAppByPath } from '@/micro-apps';
import { goToFirstValidRoute } from '@/utils/helpers';
import { queryOperationLog, getOperationLogStatus } from '@/apis/message';
import TenantDetail from '@/components/Header/TenantDetail';
import EditPwdDrawer from './edit-pwd-drawer';
import ChangelogDrawer from './changelog-drawer';
import Notify from './notify';

const initialState = {
  theme: localStorage.getItem('theme') || THEMES.LIGHT,
};
const actions = initGlobalState(initialState);

export default {
  components: {
    BizIcon,
    EditPwdDrawer,
    ChangelogDrawer,
    Notify,
    TenantDetail,
  },
  computed: {
    ...mapState('user', ['userInfo', 'isChangePassword']),
    ...mapState(['contractInfo']),
    contractStateText() {
      // ON: 续约中，OFF 已结束(过期)，FREEZE: 暂停(终止)
      const state = {
        ON: '续约中',
        OFF: '已过期',
        FREEZE: '已终止',
      };
      const { contractState } = this.contractInfo;
      return state[contractState];
    },
  },
  watch: {
    isChangePassword: {
      handler(newVal) {
        if (newVal) {
          this.showEditPwdModal = true;
          this.$store.commit('user/updateChangePwd', false);
        }
      },
      immediate: true,
    },
  },
  props: {
    routesConfig: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedMenuPath: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showEditPwdModal: false,
      showDropDown: false,
      showChangelogModal: false,
      theme: initialState.theme,
      THEMES,
      logo: process.env.LOGO,
      changelogContent: '', // 从接口获取
      hasUnreadChangelog: false, // 是否有未读的更新日志
      tenantModalVisible: false, // 租户查询弹窗是否可见
    };
  },
  mounted() {
    // 组件挂载时检查操作日志状态
    this.checkOperationLogStatus();
  },
  methods: {
    // 处理租户查询
    handleTenantQuery() {
      this.tenantModalVisible = true;
    },
    visibleChange(v) {
      this.showDropDown = v;
    },
    switchTheme(val) {
      this.theme = val ? THEMES.DARK : THEMES.LIGHT;

      const darkLink = document.querySelector('link[title=main-dark]');
      const lightLink = document.querySelector('link[title=main-light]');

      darkLink.disabled = true;
      darkLink.disabled = this.theme !== THEMES.DARK;
      lightLink.disabled = true;
      lightLink.disabled = this.theme !== THEMES.LIGHT;

      localStorage.setItem('theme', this.theme);

      // 将主题切换消息分发给子应用
      actions.setGlobalState({
        theme: this.theme,
      });
    },
    changeProduct(value) {
      this.$router.push(value);
      this.activeProduct = getAppByPath(value);
    },
    handleClickLogo() {
      goToFirstValidRoute(this.$router);
    },
    handleLogout() {
      this.$store.dispatch('user/logout');
    },
    handleEditPwd(payload) {
      this.$store.dispatch('user/editPwd', payload).then(() => {
        this.$message.success('修改成功');
        this.showEditPwdModal = false;
        this.handleLogout();
      });
    },
    handleEditPwdCancel() {
      this.showEditPwdModal = false;
    },
    showChangelogDrawer() {
      this.showChangelogModal = true;
      // 打开抽屉时获取最新数据
      this.fetchChangelogContent();
      // 用户点击查看更新日志时，将dot状态设为false（表示已读）
      this.hasUnreadChangelog = false;
    },
    handleChangelogClose() {
      this.showChangelogModal = false;
    },
    // 获取更新日志内容
    async fetchChangelogContent() {
      try {
        const response = await queryOperationLog({ sysType: 'RETAIL' });
        if (response && response.content) {
          this.changelogContent = response.content;
        } else {
          this.changelogContent = '<p>暂无更新日志</p>';
        }
      } catch (error) {
        console.error('获取更新日志失败:', error);
        this.changelogContent = '<p>获取更新日志失败，请稍后重试</p>';
      }
    },
    // 检查操作日志状态
    async checkOperationLogStatus() {
      try {
        const response = await getOperationLogStatus({ sysType: 'RETAIL' });
        // 根据接口返回的状态判断是否显示dot
        console.log(response);
        this.hasUnreadChangelog = response && response.state === 'UNREAD';
      } catch (error) {
        console.error('获取操作日志状态失败:', error);
        // 出错时默认不显示dot
        this.hasUnreadChangelog = false;
      }
    },
    updateMenu(path) {
      // header大菜单
      this.$emit('update:selected-menu-path', path);

      // 修改header大菜单后显示该大菜单下的第一个路由
      goToFirstValidRoute(this.$router, path);
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  cursor: default;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 252px;
  top: 0;
  width: calc(100% - 252px);
  height: 64px;
  padding: 0 40px;
  font-size: 16px;
  line-height: 64px;
  background-color: var(--navi-bg);
  border-bottom: 1px solid #e8e8e8;
  // box-shadow: 0 2px 6px 0px rgba(0, 0, 0, .08);
  z-index: 1;
  &__logo {
    float: left;
    height: 19px;
    width: 107px;
    line-height: 64px;
    color: white;
    cursor: pointer;
    background-size: 100% 100%;
  }

  &__menu {
    display: block;
    flex-grow: 1;
    margin-left: 53px;
    font-size: 0;

    &__item {
      display: inline-block;
      margin: 0 24px;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.45);
      border-bottom: 2px solid transparent;

      &:hover {
        color: var(--main-color);
      }

      ::v-deep &.router-link-active {
        color: var(--main-color);
        border-bottom-color: var(--main-color);
      }
    }
  }

  &__theme-switch {
    width: 140px;
    height: 32px;
    padding: 0 14px;
    border-radius: 2px;
    border: 1px solid var(--border-color-base);
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 10px;

    .antmain-switch::after {
      background: white !important;
    }
  }

  &__user {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    &__config {
      &__active {
        color: #3baebc;
        > span {
          color: #3baebc;
        }
      }
      &:hover {
        color: #3baebc;
        > span {
          color: #3baebc;
        }
      }
    }
    &__name {
      color: rgba(255, 255, 255, 0.65);
    }
    &__icon {
      position: relative;
      top: -2px;
      vertical-align: middle;
      font-size: 20px;
      color: var(--text-color-o-65);
    }

    &__menu {
      border-radius: 6px;
      background-color: var(--dropdown-bg);
      color: white;
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2),
        0px 6px 16px 0px rgba(0, 0, 0, 0.32),
        0px 3px 6px -4px rgba(0, 0, 0, 0.48);

      &__item {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px 16px;
        background-color: transparent !important;
        color: var(--text-color-o-65) !important;

        &:hover {
          background-color: var(--main-color) !important;
          color: #fff !important;
        }

        &--logout {
          color: #3baebc !important;
        }
      }
    }
  }
}
.menu-item {
  margin-right: 56px;
  cursor: pointer;

  &.active {
    color: var(--main-color);
  }
}
.header__user__changelog {
  height: 30px;
  line-height: 28px;
  background-color: rgba(68, 199, 216, 0.1) !important;
  padding: 0 6px;
  color: #333333 !important;
  border-color: rgba(68, 199, 216, 0.5) !important;
  box-sizing: border-box;
  ::v-deep.anticon {
    position: relative;
    top: 1px;
  }
  ::v-deep span {
    margin-left: 4px !important;
  }
}
.header__divider {
  margin-left: 30px;
}
.contract {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1;
  margin-left: 20px;
}
.contract-state {
  font-size: 14px;
  margin-bottom: 4px;
  color: var(--main-color);
}
.contract-date {
  font-size: 12px;
}
</style>
